export default "__VITE_ASSET__BRCI1hUt__"